import { get } from '@App/container';

/**
 * @return {AudioApi}
 */
export function useAudioApi() {
    return get('audio');
}
